const useStyles = (theme) => ({
  boxContainer: {
    height: "100%",
    containerType: "size",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexDirection: "column",
    backgroundColor: theme.palette.background.cardStatus,
    borderRadius: 2,
    paddingY: 2,
  },
  boxContainerSizeChart: {
    overflow: "hidden",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexDirection: "column",
    "&:hover": {
      overflow: "visible",
    },
  },
  boxLegend: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    flexDirection: "column",
    paddingX: 2,
  },
});

export default useStyles;
